import { type ReactNode } from "react";

interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}

/**
 * CSS-only scroll-reveal animation using Tailwind's animate-fade-in.
 * No JS IntersectionObserver needed — pure CSS animation triggered on paint.
 * For below-fold sections wrapped in LazySection, the animation fires
 * when LazySection renders the children (already in viewport).
 */
const AnimatedSection = ({ children, className = "", delay = 0 }: AnimatedSectionProps) => {
  // Anti-flicker: removed `animate-fade-in` (translateY 10px) — when sections
  // mount inside <LazySection> during scroll, the transform caused a visible
  // jitter as each block "slid in" while the user was already scrolling past.
  // Keep the component as a passthrough so existing call sites still work.
  void delay;
  return <div className={className}>{children}</div>;
};

export default AnimatedSection;
